<template>
  <div>
    <a-modal
      v-model="visible"
      :title="title"
      ok-text="确认"
      cancel-text="取消"
      :centered="true"
      :footer="null"
      :width="684"
      :zIndex="1030"
    >
      <ValidationObserver ref="formEmployee" v-slot="{ handleSubmit }">
        <CForm
          class="create_form"
          @submit.prevent="handleSubmit(updateOverTimeRequest)"
          v-if="employeeOverTimeInfo.over_time_request_id || disabled"
        >
          <CRow class="form-input" v-if="projectsEmployees">
            <CCol md="12" class="form-field">
              <label class="form-label">
                {{ $t("commons.label_project_name") }}
                <span class="require">*</span>
              </label>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="overtime.project_name"
              >
                <select
                  class="form-control"
                  v-model="employeeOverTimeInfo.project_id"
                  @change="changeProject()"
                  :disabled="disabled"
                >
                  <option
                    v-for="(option, index) in projectsEmployees"
                    :key="index"
                    :value="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>
          </CRow>
          <CRow class="form-input">
            <CCol md="12" class="form-field">
              <label class="form-label">
                {{ $t("commons.label_approve_person1") }}
                <span class="require">*</span>
              </label>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="overtime.approve"
              >
                <select
                  class="form-control"
                  v-model="employeeOverTimeInfo.approve_person_1"
                  v-if="
                    employeeOverTimeInfo.project_id &&
                    employeeOverTimeInfo.approve_person_1
                  "
                  :disabled="disabled"
                >
                  <option
                    v-for="(option, index) in approvalPersons[
                      employeeOverTimeInfo.project_id
                    ]['level1']"
                    :key="index"
                    :value="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>
                <select
                  class="form-control"
                  v-model="employeeOverTimeInfo.approve_person_1"
                  :disabled="disabled"
                  v-else
                >
                  <option
                    v-for="(option, index) in approvalPersons['level1']"
                    :key="index"
                    :value="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>
          </CRow>
          <CRow
            class="form-input"
            v-if="
              employeeOverTimeInfo.approve_person_2 &&
              ((employeeOverTimeInfo.project_id &&
                approvalPersons[employeeOverTimeInfo.project_id]['level2']) ||
                (!employeeOverTimeInfo.project_id &&
                  approvalPersonList['level2'] &&
                  approvalPersonList['level2'].length > 0))
            "
          >
            <CCol md="12" class="form-field">
              <label class="form-label">
                {{ $t("commons.label_approve_person2") }}
                <span class="require">*</span>
              </label>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="overtime.approve2"
              >
                <select
                  class="form-control"
                  v-model="employeeOverTimeInfo.approve_person_2"
                  v-if="
                    employeeOverTimeInfo.project_id &&
                    approvalPersons[employeeOverTimeInfo.project_id][
                      'level2'
                    ] &&
                    employeeOverTimeInfo.approve_person_2
                  "
                  :disabled="disabled"
                >
                  <option
                    v-for="(option, index) in approvalPersons[
                      employeeOverTimeInfo.project_id
                    ]['level2']"
                    :key="index"
                    :value="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>
                <select
                  class="form-control"
                  v-model="employeeOverTimeInfo.approve_person_2"
                  v-else
                  :disabled="disabled"
                >
                  <option
                    v-for="(option, index) in approvalPersonList['level2']"
                    :key="index"
                    :value="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>
          </CRow>
          <CRow
            class="form-input"
            v-if="
              (employeeOverTimeInfo.project_id &&
                approvalPersons[employeeOverTimeInfo.project_id]['level3']) ||
              (!employeeOverTimeInfo.project_id &&
                approvalPersonList['level3'] &&
                approvalPersonList['level3'].length > 0)
            "
          >
            <CCol md="12" class="form-field">
              <label class="form-label">
                {{ $t("commons.label_approve_person3") }}
                <span class="require">*</span>
              </label>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="overtime.approve3"
              >
                <select
                  class="form-control"
                  v-model="employeeOverTimeInfo.approve_person_3"
                  v-if="
                    employeeOverTimeInfo.project_id &&
                    approvalPersons[employeeOverTimeInfo.project_id]['level3']
                  "
                  :disabled="disabled"
                >
                  <option
                    v-for="(option, index) in approvalPersons[
                      employeeOverTimeInfo.project_id
                    ]['level3']"
                    :key="index"
                    :value="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>
                <select
                  class="form-control"
                  v-model="employeeOverTimeInfo.approve_person_3"
                  :disabled="disabled"
                  v-else
                >
                  <option
                    v-for="(option, index) in approvalPersonList['level3']"
                    :key="index"
                    :value="option.id"
                  >
                    {{ option.name }}
                  </option>
                </select>
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>
          </CRow>
          <CRow class="form-input">
            <CCol md="12" class="form-field">
              <label class="form-label">
                {{ $t("overtime.date") }}
                <span class="require">*</span>
              </label>
              <div>
                <a-date-picker
                  format="DD/MM/YYYY"
                  :disabled-date="disabledDate"
                  :disabled="disabled"
                  v-model="date"
                  :placeholder="$t('overtime.date')"
                  @change="onChange"
                />
              </div>

              <!-- <DatePickerOT
                :propsDate="
                  employeeOverTimeInfo.date ? employeeOverTimeInfo.date : ''
                "
                v-on:emitDate="workDate"
                :rules="{ required_date: true }"
                :name="'overtime.date'"
              /> -->
            </CCol>
          </CRow>
          <CRow class="form-input">
            <CCol md="12" class="form-field">
              <label class="form-label">
                {{ $t("overtime.start_time") }}
                <span class="require">*</span>
              </label>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="overtime.start_time"
              >
                <b-form-input
                  type="text"
                  v-model="employeeOverTimeInfo.start_time"
                  v-mask="'##:##'"
                  placeholder="HH:mm"
                  :disabled="disabled"
                />
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>
          </CRow>
          <CRow class="form-input">
            <CCol md="12" class="form-field">
              <label class="form-label">
                {{ $t("overtime.end_time") }}
                <span class="require">*</span>
              </label>
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                name="overtime.end_time"
              >
                <b-form-input
                  type="text"
                  v-model="employeeOverTimeInfo.end_time"
                  v-mask="'##:##'"
                  placeholder="HH:mm"
                  :disabled="disabled"
                />
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>
          </CRow>
          <CRow class="form-input">
            <CCol md="12" class="form-field">
              <label class="form-label">
                {{ $t("commons.label_reason") }}
                <span class="require">*</span>
              </label>
              <ValidationProvider
                rules="required|max:512"
                v-slot="{ errors }"
                name="overtime.reason"
              >
                <b-form-textarea
                  id="textarea"
                  v-model="employeeOverTimeInfo.reason"
                  rows="6"
                  max-rows="8"
                  :disabled="disabled"
                ></b-form-textarea>
                <span class="required">{{ errors[0] }}</span>
              </ValidationProvider>
            </CCol>
          </CRow>
          <CRow class="form-button">
            <CCol md="12" class="employees-form-ot" v-if="disabled === false">
              <CButton type="submit" class="save-info"
              >{{ $t("label.save_infomation") }}
              </CButton>
              <CButton
                class="cancel-employee"
                type="button"
                @click="hideModal()"
              >{{ $t("commons.cancel") }}
              </CButton>
            </CCol>
          </CRow>
        </CForm>
      </ValidationObserver>
    </a-modal>
  </div>
</template>

<script>
import {ValidationProvider, ValidationObserver} from "vee-validate";
import {mapGetters, mapActions} from "vuex";
import moment from "moment";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },

  props: ["id"],

  computed: {
    ...mapGetters({
      projectsEmployees: "overtime-request/projectsEmployees",
      employeeOverTimeInfo: "overtime-request/employeeOverTimeInfo",
      approvalPersons: "overtime-request/approvalPersons",
      approvalPersonList: "commons/approvalPersonList",
    }),
  },

  data() {
    return {
      title: this.$t("popup.overtime.label_popup_edit"),
      visible: false,
      date: moment(),
      employees: [],
      approvalPerson: [],
      disabled: false,
    };
  },

  methods: {
    ...mapActions("layout", ["setLoading"]),
    onChange(date) {
      this.employeeOverTimeInfo.date = moment(date).format("DD/MM/YYYY");
    },

    disabledDate(current) {
      return (
        current < moment().subtract(7, "days") ||
        moment(current).isSameOrAfter(moment(), "day")||this.disabled === true
      );
    },

    async showModal(id, status, date) {
      status !== 1 && date === false ?  this.disabled = true :  this.disabled = false;
      if (id) {
        this.$root.$loading.start();
        this.visible = true;
        await this.$store.dispatch("overtime-request/getProjectEmployee");
        await this.$store.dispatch("overtime-request/getApprovalPerson");
        await this.$store.dispatch("commons/getApprovePersonBySetting");
        await this.$store.dispatch("overtime-request/getInfoOverTime", id);
        this.date = moment(this.employeeOverTimeInfo.date, "DD/MM/YYYY");
        // if (
        //   ((this.projectsEmployees &&
        //     this.approvalPersons[this.employeeOverTimeInfo.project_id][
        //       "level2"
        //     ]) ||
        //     (!this.projectsEmployees &&
        //       this.approvalPersons["level2"].length > 0)) &&
        //   !this.employeeOverTimeInfo.approve_person_2
        // ) {
        //   this.employeeOverTimeInfo.approve_person_2 =
        //     this.employeeOverTimeInfo.approve_person_1;
        // }
        this.$root.$loading.finish();
      }
    },

    hideModal() {
      this.visible = false;
    },

    async updateOverTimeRequest() {
      this.$root.$loading.start();
      await this.$store
        .dispatch("overtime-request/updateOverTime", this.employeeOverTimeInfo)
        .then(() => {
          let message = this.$t("overtime.message_update_success");
          this.$toast(message, null, 2000, "b-toaster-top-center", "success");
          this.$emit("fetchData");
          this.visible = false;
          this.$root.$loading.finish();
        })
        .catch(() => {
          this.$root.$loading.finish();
        });
    },

    workDate(data) {
      this.employeeOverTimeInfo.date = data;
    },

    changeProject() {
      this.employeeOverTimeInfo.approve_person_1 =
        this.approvalPersons[this.employeeOverTimeInfo.project_id]["level1"][0][
          "id"
          ];
      this.employeeOverTimeInfo.approve_person_2 = this.approvalPersons[
        this.employeeOverTimeInfo.project_id
        ]["level2"]
        ? this.approvalPersons[this.employeeOverTimeInfo.project_id][
          "level2"
          ][0]["id"]
        : "";
    },
  },
};
</script>

<style lang="scss" scoped>
.create_form {
  max-width: 440px;
  margin: 0 auto;

  .form-input {
    margin-bottom: 16px;

    .form-field {
      .form-label {
        font-weight: 700;
        font-size: 14px;
        color: #303c54;

        .require {
          color: #f03d3e;
        }
      }

      /deep/ .ant-calendar-picker {
        width: 100%;

        .ant-input {
          height: 35px;
        }
      }

      .textarea-input {
        border: 1px solid #cfcfcf;
        border-radius: 10px;
      }

      .required {
        color: #f03d3e;
      }
    }
  }

  .form-button {
    .employees-form-ot {
      display: flex;
      gap: 20px;

      .save-info {
        width: 50%;
        background: #3d4cdc;
        border-radius: 10px;
        font-weight: 700;
        font-size: 14px;
        color: #ffffff;
      }

      .cancel-employee {
        width: 50%;
        background: #ececec;
        border-radius: 10px;
        color: #6f6f6f;
        font-weight: 700;
        font-size: 14px;
      }
    }
  }
}
</style>
